module.exports = __webpack_public_path__ + "img/leveler-2-off.75c66a57.png";